export const MIN_NAME_PART_LENGTH = 3;

// Construídos com `new RegExp` porque o target do tsconfig é es5 e a flag `u`
// não é aceita em literais de regex. Em runtime todos os navegadores suportam.
const LETTER = '\\p{L}\\p{Mn}';

// Uma parte do nome é uma ou mais letras (qualquer alfabeto, acentos inclusos),
// podendo ser unidas por hífen ou apóstrofo posicionados entre duas letras.
const VALID_NAME_PART = new RegExp(
  `^[${LETTER}]+(?:[-'][${LETTER}]+)*$`,
  'u'
);

const DISALLOWED_NAME_CHARS = new RegExp(`[^${LETTER}\\-'\\s]`, 'gu');

const CURLY_APOSTROPHE = /’/g;

export const normalizeFullName = (name: string): string =>
  (name || '')
    .replace(CURLY_APOSTROPHE, "'")
    .trim()
    .replace(/\s+/g, ' ');

export const isValidNamePart = (part: string): boolean =>
  !!part && VALID_NAME_PART.test(part);

export const hasValidNameCharacters = (name: string): boolean => {
  const parts = normalizeFullName(name).split(' ').filter(Boolean);
  return parts.length > 0 && parts.every(isValidNamePart);
};

// Same structural rules as the backend NameUtils:
// at least two space-separated parts, first part with 3+ characters,
// and either the second part has 3+ characters or there are 3+ parts.
// Every part must also contain only letters, hyphens and apostrophes.
export const isValidFullName = (name: string): boolean => {
  const parts = normalizeFullName(name).split(' ').filter(Boolean);
  if (parts.length < 2) return false;
  if (parts[0].length < MIN_NAME_PART_LENGTH) return false;
  if (parts.length < 3 && parts[1].length < MIN_NAME_PART_LENGTH) return false;
  return parts.every(isValidNamePart);
};

// Typing filter: keeps letters, accents, spaces, hyphens and apostrophes.
// Curly apostrophes are converted so they match the validation rules.
export const filterNameChars = (value: string): string =>
  (value || '').replace(CURLY_APOSTROPHE, "'").replace(DISALLOWED_NAME_CHARS, '');
